import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { useFormik } from 'formik';
import {
  Button,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { BackButton, Details } from '../../../components';
import { updateTemplate } from '../../admin/templates/slice';
import { Template } from '@/types';

type FormValues = Partial<Template>;

const Settings = () => {
  const dispatch = useAppDispatch();
  const { templateId } = useParams();
  const template = useAppSelector((state) => state?.templates[templateId]);

  const initialValues: Partial<Template> = {};

  const formik = useFormik({
    initialValues,
    onSubmit: () => {
      const values: FormValues = { ...formik.values };
      console.error(values);
      dispatch(updateTemplate(values));
    },
  });

  useEffect(() => {
    if (template) {
      formik.setValues({
        id: templateId,
        title: template.title,
        isPublished: !!template.isPublished,
        isPrivate: !!template.isPrivate,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template, templateId]);

  return (
    <Stack spacing={2} py={4}>
      <Typography variant="h1">Settings</Typography>
      <BackButton />

      <Stack flexDirection={'row'} height={'50px'} alignItems={'space-between'}>
        <Details
          label="Título"
          children={
            <TextField
              margin="normal"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
            />
          }
        />
      </Stack>

      <Stack flexDirection={'row'} height={'50px'} alignItems={'space-between'}>
        <Details
          label={'Visibilidad'}
          description={
            template?.isPrivate ? 'Si está Privado' : 'No está Privado'
          }
          children={
            <FormControlLabel
              control={
                <Switch
                  name="isPrivate"
                  checked={formik.values.isPrivate}
                  onChange={formik.handleChange}
                />
              }
              label="Privado"
            />
          }
        />
      </Stack>
      <Stack flexDirection={'row'} height={'50px'}>
        <Details
          label={'Status'}
          description={
            template?.isPublished ? 'Si está Publicado' : 'No está Publicado'
          }
          children={
            <FormControlLabel
              control={
                <Switch
                  name="isPublished"
                  checked={formik.values.isPublished}
                  onChange={formik.handleChange}
                />
              }
              label="Publicado"
            />
          }
        />
      </Stack>
      <Button variant="contained" onClick={formik.handleSubmit}>
        Guardar
      </Button>
    </Stack>
  );
};

export default Settings;
